import { createRoot } from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import App from "./App.tsx";
import "./index.css";
import { initSentry } from "./lib/sentry";

initSentry();

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  capture_pageview: false, // We fire manually on SPA route changes
  autocapture: true,
  persistence: "localStorage+cookie" as const,
};

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN;

createRoot(document.getElementById("root")!).render(
  posthogKey ? (
    <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
      <App />
    </PostHogProvider>
  ) : (
    <App />
  ),
);
